import { ContractExtractedEntityInfo } from '@evidentid/tprm-portal-lib/models/contract-extraction';

import { FieldMeta } from '@/modules/dynamic-form/models/FieldMeta.model';
import { FieldPath } from '@/modules/dynamic-form/models/FieldPath.model';

const entityInfoToFieldPath: Record<keyof ContractExtractedEntityInfo, FieldPath> = {
    name: 'displayName' as FieldPath,
    phoneNumber: 'contactPhoneNumber' as FieldPath,
    address: 'address' as FieldPath,
    doingBusinessAs: 'doingBusinessAs' as FieldPath,
    legalName: 'legalName' as FieldPath,
};

export function seedEntityFormValuesFromEntityInfo(
    fields: FieldMeta[],
    entityInfo: ContractExtractedEntityInfo | null,
): Record<FieldPath, any> {
    const valueByPath: Record<string, any> = {};
    if (entityInfo) {
        const entries = Object.entries(entityInfoToFieldPath) as [ keyof ContractExtractedEntityInfo, FieldPath ][];
        for (const [ infoKey, fieldPath ] of entries) {
            const extracted = entityInfo[infoKey];
            if (extracted) {
                valueByPath[fieldPath] = extracted.value;
            }
        }
    }
    return fields.reduce((acc, field) => {
        acc[field.path] = field.path in valueByPath ? valueByPath[field.path] : field.defaultValue;
        return acc;
    }, {} as Record<FieldPath, any>);
}
